export const TT_AUTHORIZATION_NOTES_MAX = 2500;

export const TT_AUTHORIZATION_NOTES_LABEL = 'Authorization Notes';

export const TT_AUTHORIZATION_NOTES_PLACEHOLDER =
    'Please include appointment address, facility information, appointment date and time, and any special instructions.';

export const TT_OTHER_FIELD_MAX = 50;


